// Expense Type Getters

export const getExpenseTypeList = state => {
  return state.expenseTypeList
}

export const getExpenseTypeInfo = state => {
  return state.expenseTypeInfo
}

export const getFullExpenseTypesList = state => {
  return state.fullExpenseTypesList
}
